import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';

setAutoFreeze(false); // 禁止凍結

const localMain = JSON.parse(sessionStorage.getItem('custom-itinerary-main'));

const initialState = {
  type: localMain?.type ?? '',
  m_mid: localStorage.getItem('m_mid') ?? '',
  m_class: localStorage.getItem('m_class') ?? '',
  travel_no: localMain?.travel_no ?? '',
  travel_title: localMain?.travel_title ?? '', // 行程
  country: localMain?.country ?? '', // 國家地區
  from_city: localMain?.from_city ?? '', // 出發城市
  images: localMain?.images ?? '', // 行程圖片
  countryId: localMain?.countryId ?? '', // 國家id (最上層)
};

export const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    mainUpdate: (state, action) => {
      sessionStorage.setItem('custom-itinerary-main', JSON.stringify(action.payload));
      return action.payload;
    },
  },
});

export const mainSelect = (state) => state.main;
export const { mainUpdate } = mainSlice.actions;
export default mainSlice.reducer;
